import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  Badge, Button, Card, CardBody, CardTitle, Col, Container, Form, FormGroup, Label,
  Nav, NavItem, NavLink, Row, TabContent, TabPane
} from "reactstrap"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import classnames from "classnames"
import InputMask from "react-input-mask"
import toastr from "toastr"

import Breadcrumbs from "components/Common/Breadcrumb"
import AlertaSemVinculo from "../../components/Common/alerta-sem-vinculo"
import StickerToolbarButtons from "../../components/Common/sticker-toolbar-buttons"
import FormSelectCompany from "../../components/Common/form-select-company"
import FormInputText from "../../components/Common/form-input-text"
import FormInputNumber from "../../components/Common/form-input-number"
import FormInputSelect from "../../components/Common/form-input-select"
import FormInputSwitch from "../../components/Common/form-input-switch"
import FormInputCpfCnpj from "../../components/Common/form-input-cpf-cnpj"
import usePermission from "helpers/permission/usePermission"
import { getCompanies } from "../../helpers/utils"
import {
  buscarFastfoodMobileConfigPorEmpresa,
  cadastrarFastfoodMobileConfig,
  editarFastfoodMobileConfig
} from "../../store/auth/profile/actions"
import { navegarBreadCrumb } from "../../store/navigator/actions"
import { describeSaldoLicenca, isLimiteLicencaExcedido } from "./const/fastfoodMobileLicenca"
import {
  getAdquirenteOptions,
  getAmbienteOptions,
  getConexaoModoOptions,
  getConexaoPrioridadeOptions,
  getModeloImpressaoOptions,
  getProtocoloOptions,
  getSitefTipoIntegracaoOptions,
  getTunnelProvedorOptions
} from "./const/fastfoodMobileOptions"

const DEFAULTS = {
  ativo: "S",
  habilitaFastfoodMobile: "S",
  licencaQtdDispositivos: null,
  ambiente: "PRODUCAO",
  conexaoModo: "LOCAL",
  conexaoPrioridade: "LOCAL_PRIMEIRO",
  permitirTrocaModoConexaoNoApp: "S",
  datasnapLocalAtivo: "S",
  datasnapLocalProtocolo: "HTTP",
  datasnapLocalHost: null,
  datasnapLocalPorta: 1032,
  datasnapLocalPath: "/datasnap/rest",
  datasnapLocalUrlOverride: null,
  permitirHttpLocalCleartext: "S",
  datasnapHttpsTunnelAtivo: "N",
  datasnapHttpsTunnelProvedor: "CLOUDFLARE",
  datasnapHttpsTunnelUrl: null,
  datasnapHttpsTunnelHost: null,
  datasnapHttpsTunnelPath: "/datasnap/rest",
  validarSslHttpsTunnel: "S",
  cloudflareTunnelId: null,
  cloudflareAccessAtivo: "N",
  cloudflareAccessAudience: null,
  timeoutConexaoMs: 15000,
  timeoutLeituraMs: 30000,
  tentativasConexao: 2,
  fallbackAutomatico: "S",
  limparCacheAoTrocarEmpresa: "S",
  limparCacheAoTrocarUrl: "S",
  sincronizarConfiguracaoAoEntrar: "S",
  sincronizarProdutosAoEntrar: "N",
  intervaloSincronizacaoMin: 0,
  permitirMesa: "S",
  permitirComanda: "S",
  permitirDelivery: "N",
  permitirPagamentoSmartpos: "N",
  adquirentePadrao: "NENHUMA",
  imprimirContaAoFechar: "S",
  bloquearMesaFechada: "S",
  permitirReimpressaoComprovante: "S",
  usarImpressaoRede: "N",
  impressoraRedeIp: null,
  impressoraRedePorta: 9100,
  modeloImpressao: null,
  appMinVersionCode: 0,
  appVersionCodeRecomendada: 0,
  bloquearAppDesatualizado: "N",
  mensagemBloqueioApp: null,
  habilitaTefSitef: "N",
  sitefTipoIntegracao: "NENHUMA",
  sitefEmpresa: null,
  sitefEndereco: null,
  sitefTerminal: null,
  sitefCnpjEstabelecimento: null,
  sitefCnpjAutomacao: null,
  sitefCnpjFacilitador: null,
  sitefComExterna: 0,
  sitefDoubleValidation: "N",
  sitefModalidadePadrao: 0,
  sitefHabilitaPix: "S",
  sitefHabilitaDebito: "S",
  sitefHabilitaCredito: "S",
  sitefHabilitaCancelamento: "S",
  sitefHabilitaReimpressao: "S",
  sitefTimeoutColeta: 60,
  sitefPinpadMac: null,
  sitefRestricoes: null,
  sitefConfigJson: null,
  configuracaoJson: null
}

const MaskedIpInput = ({ attribute, label, tooltip, value, setValue }) => (
  <FormGroup className="mb-4" row>
    <Label htmlFor={ attribute + "-text" } className="col-form-label col-lg-3">
      { label }
    </Label>
    <Col lg="3">
      <InputMask
        mask="999.999.999.999"
        maskChar={ null }
        id={ attribute + "-text" }
        name={ attribute + "-text" }
        className="form-control"
        value={ value || "" }
        title={ tooltip }
        onChange={ e => setValue(e.target.value) }
      />
    </Col>
  </FormGroup>
)

const ResumoLicencaDispositivos = ({ label, ativos, inativos, limite, saldo, t }) => {
  const saldoDescricao = describeSaldoLicenca(limite, saldo)
  const corAtivos = isLimiteLicencaExcedido(limite, ativos) ? "danger" : "success"

  return (
    <FormGroup className="mb-4" row>
      <Label className="col-form-label col-lg-3">{ label }</Label>
      <Col lg="9">
        <div className="d-flex flex-wrap align-items-center gap-2 pt-2">
          <Badge className={ `font-size-12 badge-soft-${corAtivos}` } color={ corAtivos } pill>
            { t("fastfoodmobile.config.licenca-dispositivos-resumo.ativos", { quantidade: ativos }) }
          </Badge>
          <Badge className="font-size-12 badge-soft-secondary" color="secondary" pill>
            { t("fastfoodmobile.config.licenca-dispositivos-resumo.inativos", { quantidade: inativos }) }
          </Badge>
          <Badge className={ `font-size-12 badge-soft-${saldoDescricao.color}` } color={ saldoDescricao.color } pill>
            { t("fastfoodmobile.config.licenca-dispositivos-resumo.saldo", { saldo: saldoDescricao.label }) }
          </Badge>
        </div>
      </Col>
    </FormGroup>
  )
}

const CadastrarFastfoodMobileConfig = props => {
  const { t } = props

  const isInforangra = props.user?.usuario_info
  const usePermissionEdit = usePermission("fastfoodMobileConfig_editar") && isInforangra
  const usePermissionInsert = usePermission("fastfoodMobileConfig_inserir") && isInforangra
  const possuiVinculo = (props.user?.vinculos || []).some(vinculo => ["A", "T"].includes(vinculo.vinculo_status))

  const isVisualizar = new URLSearchParams(props.location?.search).get("visualizar") === "true"
  const tituloTela = isVisualizar
    ? "breadcrumb.fastfoodmobile.config.visualizacao"
    : (props.match.params.idEmpresa
      ? "breadcrumb.fastfoodmobile.config.edicao"
      : "breadcrumb.fastfoodmobile.config.inclusao")

  const voltarParaListagem = () => props.history.push("/fastfood-mobile-configuracoes")

  const [tab, setTab] = useState("geral")
  const [companies, setCompanies] = useState([{ label: "Todas", value: "" }])
  const [empresaId, setEmpresaId] = useState() // idEmpresa (código de negócio)
  const [empresaIdInterno, setEmpresaIdInterno] = useState() // empresa_id (tb_empresa.id)
  const [cnpjSemMascara, setCnpjSemMascara] = useState()
  const [id, setId] = useState()

  const [ativo, setAtivo] = useState(DEFAULTS.ativo)
  const [habilitaFastfoodMobile, setHabilitaFastfoodMobile] = useState(DEFAULTS.habilitaFastfoodMobile)
  const [licencaQtdDispositivos, setLicencaQtdDispositivos] = useState(DEFAULTS.licencaQtdDispositivos)
  const [ambiente, setAmbiente] = useState(DEFAULTS.ambiente)

  const [conexaoModo, setConexaoModo] = useState(DEFAULTS.conexaoModo)
  const [conexaoPrioridade, setConexaoPrioridade] = useState(DEFAULTS.conexaoPrioridade)
  const [permitirTrocaModoConexaoNoApp, setPermitirTrocaModoConexaoNoApp] = useState(DEFAULTS.permitirTrocaModoConexaoNoApp)
  const [fallbackAutomatico, setFallbackAutomatico] = useState(DEFAULTS.fallbackAutomatico)
  const [timeoutConexaoMs, setTimeoutConexaoMs] = useState(DEFAULTS.timeoutConexaoMs)
  const [timeoutLeituraMs, setTimeoutLeituraMs] = useState(DEFAULTS.timeoutLeituraMs)
  const [tentativasConexao, setTentativasConexao] = useState(DEFAULTS.tentativasConexao)

  const [datasnapLocalAtivo, setDatasnapLocalAtivo] = useState(DEFAULTS.datasnapLocalAtivo)
  const [datasnapLocalProtocolo, setDatasnapLocalProtocolo] = useState(DEFAULTS.datasnapLocalProtocolo)
  const [datasnapLocalHost, setDatasnapLocalHost] = useState(DEFAULTS.datasnapLocalHost)
  const [datasnapLocalPorta, setDatasnapLocalPorta] = useState(DEFAULTS.datasnapLocalPorta)
  const [datasnapLocalPath, setDatasnapLocalPath] = useState(DEFAULTS.datasnapLocalPath)
  const [datasnapLocalUrlOverride, setDatasnapLocalUrlOverride] = useState(DEFAULTS.datasnapLocalUrlOverride)
  const [permitirHttpLocalCleartext, setPermitirHttpLocalCleartext] = useState(DEFAULTS.permitirHttpLocalCleartext)

  const [datasnapHttpsTunnelAtivo, setDatasnapHttpsTunnelAtivo] = useState(DEFAULTS.datasnapHttpsTunnelAtivo)
  const [datasnapHttpsTunnelProvedor, setDatasnapHttpsTunnelProvedor] = useState(DEFAULTS.datasnapHttpsTunnelProvedor)
  const [datasnapHttpsTunnelUrl, setDatasnapHttpsTunnelUrl] = useState(DEFAULTS.datasnapHttpsTunnelUrl)
  const [datasnapHttpsTunnelHost, setDatasnapHttpsTunnelHost] = useState(DEFAULTS.datasnapHttpsTunnelHost)
  const [datasnapHttpsTunnelPath, setDatasnapHttpsTunnelPath] = useState(DEFAULTS.datasnapHttpsTunnelPath)
  const [validarSslHttpsTunnel, setValidarSslHttpsTunnel] = useState(DEFAULTS.validarSslHttpsTunnel)
  const [cloudflareTunnelId, setCloudflareTunnelId] = useState(DEFAULTS.cloudflareTunnelId)
  const [cloudflareAccessAtivo, setCloudflareAccessAtivo] = useState(DEFAULTS.cloudflareAccessAtivo)
  const [cloudflareAccessAudience, setCloudflareAccessAudience] = useState(DEFAULTS.cloudflareAccessAudience)

  const [limparCacheAoTrocarEmpresa, setLimparCacheAoTrocarEmpresa] = useState(DEFAULTS.limparCacheAoTrocarEmpresa)
  const [limparCacheAoTrocarUrl, setLimparCacheAoTrocarUrl] = useState(DEFAULTS.limparCacheAoTrocarUrl)
  const [sincronizarConfiguracaoAoEntrar, setSincronizarConfiguracaoAoEntrar] = useState(DEFAULTS.sincronizarConfiguracaoAoEntrar)
  const [sincronizarProdutosAoEntrar, setSincronizarProdutosAoEntrar] = useState(DEFAULTS.sincronizarProdutosAoEntrar)
  const [intervaloSincronizacaoMin, setIntervaloSincronizacaoMin] = useState(DEFAULTS.intervaloSincronizacaoMin)

  const [permitirMesa, setPermitirMesa] = useState(DEFAULTS.permitirMesa)
  const [permitirComanda, setPermitirComanda] = useState(DEFAULTS.permitirComanda)
  const [permitirDelivery, setPermitirDelivery] = useState(DEFAULTS.permitirDelivery)
  const [imprimirContaAoFechar, setImprimirContaAoFechar] = useState(DEFAULTS.imprimirContaAoFechar)
  const [bloquearMesaFechada, setBloquearMesaFechada] = useState(DEFAULTS.bloquearMesaFechada)
  const [permitirReimpressaoComprovante, setPermitirReimpressaoComprovante] = useState(DEFAULTS.permitirReimpressaoComprovante)

  const [permitirPagamentoSmartpos, setPermitirPagamentoSmartpos] = useState(DEFAULTS.permitirPagamentoSmartpos)
  const [adquirentePadrao, setAdquirentePadrao] = useState(DEFAULTS.adquirentePadrao)
  const [usarImpressaoRede, setUsarImpressaoRede] = useState(DEFAULTS.usarImpressaoRede)
  const [impressoraRedeIp, setImpressoraRedeIp] = useState(DEFAULTS.impressoraRedeIp)
  const [impressoraRedePorta, setImpressoraRedePorta] = useState(DEFAULTS.impressoraRedePorta)
  const [modeloImpressao, setModeloImpressao] = useState(DEFAULTS.modeloImpressao)

  const [appMinVersionCode, setAppMinVersionCode] = useState(DEFAULTS.appMinVersionCode)
  const [appVersionCodeRecomendada, setAppVersionCodeRecomendada] = useState(DEFAULTS.appVersionCodeRecomendada)
  const [bloquearAppDesatualizado, setBloquearAppDesatualizado] = useState(DEFAULTS.bloquearAppDesatualizado)
  const [mensagemBloqueioApp, setMensagemBloqueioApp] = useState(DEFAULTS.mensagemBloqueioApp)

  const [habilitaTefSitef, setHabilitaTefSitef] = useState(DEFAULTS.habilitaTefSitef)
  const [sitefTipoIntegracao, setSitefTipoIntegracao] = useState(DEFAULTS.sitefTipoIntegracao)
  const [sitefEmpresa, setSitefEmpresa] = useState(DEFAULTS.sitefEmpresa)
  const [sitefEndereco, setSitefEndereco] = useState(DEFAULTS.sitefEndereco)
  const [sitefTerminal, setSitefTerminal] = useState(DEFAULTS.sitefTerminal)
  const [sitefCnpjEstabelecimento, setSitefCnpjEstabelecimento] = useState(DEFAULTS.sitefCnpjEstabelecimento)
  const [sitefCnpjAutomacao, setSitefCnpjAutomacao] = useState(DEFAULTS.sitefCnpjAutomacao)
  const [sitefCnpjFacilitador, setSitefCnpjFacilitador] = useState(DEFAULTS.sitefCnpjFacilitador)
  const [sitefComExterna, setSitefComExterna] = useState(DEFAULTS.sitefComExterna)
  const [sitefDoubleValidation, setSitefDoubleValidation] = useState(DEFAULTS.sitefDoubleValidation)
  const [sitefModalidadePadrao, setSitefModalidadePadrao] = useState(DEFAULTS.sitefModalidadePadrao)
  const [sitefHabilitaPix, setSitefHabilitaPix] = useState(DEFAULTS.sitefHabilitaPix)
  const [sitefHabilitaDebito, setSitefHabilitaDebito] = useState(DEFAULTS.sitefHabilitaDebito)
  const [sitefHabilitaCredito, setSitefHabilitaCredito] = useState(DEFAULTS.sitefHabilitaCredito)
  const [sitefHabilitaCancelamento, setSitefHabilitaCancelamento] = useState(DEFAULTS.sitefHabilitaCancelamento)
  const [sitefHabilitaReimpressao, setSitefHabilitaReimpressao] = useState(DEFAULTS.sitefHabilitaReimpressao)
  const [sitefTimeoutColeta, setSitefTimeoutColeta] = useState(DEFAULTS.sitefTimeoutColeta)
  const [sitefPinpadMac, setSitefPinpadMac] = useState(DEFAULTS.sitefPinpadMac)
  const [sitefRestricoes, setSitefRestricoes] = useState(DEFAULTS.sitefRestricoes)
  const [sitefConfigJson, setSitefConfigJson] = useState(DEFAULTS.sitefConfigJson)
  const [configuracaoJson, setConfiguracaoJson] = useState(DEFAULTS.configuracaoJson)

  const podeEditarLimiteLicenca = id ? usePermissionEdit : usePermissionInsert
  const dispositivosAtivos = props.fastfoodMobileConfig?.licenca_qtd_dispositivos_ativos ?? 0
  const dispositivosInativos = props.fastfoodMobileConfig?.licenca_qtd_dispositivos_inativos ?? 0
  const saldoDispositivos = licencaQtdDispositivos === null || licencaQtdDispositivos === undefined
    ? null
    : licencaQtdDispositivos - dispositivosAtivos

  useEffect(() => {
    const tmpCompanies = getCompanies(props.user)
    setCompanies(tmpCompanies)

    const idEmpresaParam = props.match.params.idEmpresa
    const options = tmpCompanies.filter(c => c.value)
    const opcaoInicial = idEmpresaParam
      ? options.find(c => String(c.value) === String(idEmpresaParam))
      : options[0]

    if (opcaoInicial) {
      selecionarEmpresa(opcaoInicial.value, options)
    }

    return () => {
      setCompanies([])
      setEmpresaId(null)
    }
  }, [])

  useEffect(() => {
    const idEmpresaParam = props.match.params.idEmpresa
    if (idEmpresaParam) {
      props.navegarBreadCrumb({ title: "breadcrumb.fastfoodmobile.config.item", link: props.location.pathname + props.location.search, id: idEmpresaParam })
    } else {
      props.navegarBreadCrumb({ title: "breadcrumb.fastfoodmobile.config.inclusao", link: props.location.pathname })
    }
  }, [])

  const preencherFormulario = (config) => {
    setId(config?.id)
    setAtivo(config ? config.ativo : DEFAULTS.ativo)
    setHabilitaFastfoodMobile(config ? config.habilita_fastfood_mobile : DEFAULTS.habilitaFastfoodMobile)
    setLicencaQtdDispositivos(config ? config.licenca_qtd_dispositivos : DEFAULTS.licencaQtdDispositivos)
    setAmbiente(config ? config.ambiente : DEFAULTS.ambiente)
    setConexaoModo(config ? config.conexao_modo : DEFAULTS.conexaoModo)
    setConexaoPrioridade(config ? config.conexao_prioridade : DEFAULTS.conexaoPrioridade)
    setPermitirTrocaModoConexaoNoApp(config ? config.permitir_troca_modo_conexao_no_app : DEFAULTS.permitirTrocaModoConexaoNoApp)
    setFallbackAutomatico(config ? config.fallback_automatico : DEFAULTS.fallbackAutomatico)
    setTimeoutConexaoMs(config ? config.timeout_conexao_ms : DEFAULTS.timeoutConexaoMs)
    setTimeoutLeituraMs(config ? config.timeout_leitura_ms : DEFAULTS.timeoutLeituraMs)
    setTentativasConexao(config ? config.tentativas_conexao : DEFAULTS.tentativasConexao)
    setDatasnapLocalAtivo(config ? config.datasnap_local_ativo : DEFAULTS.datasnapLocalAtivo)
    setDatasnapLocalProtocolo(config ? config.datasnap_local_protocolo : DEFAULTS.datasnapLocalProtocolo)
    setDatasnapLocalHost(config ? config.datasnap_local_host : DEFAULTS.datasnapLocalHost)
    setDatasnapLocalPorta(config ? config.datasnap_local_porta : DEFAULTS.datasnapLocalPorta)
    setDatasnapLocalPath(config ? config.datasnap_local_path : DEFAULTS.datasnapLocalPath)
    setDatasnapLocalUrlOverride(config ? config.datasnap_local_url_override : DEFAULTS.datasnapLocalUrlOverride)
    setPermitirHttpLocalCleartext(config ? config.permitir_http_local_cleartext : DEFAULTS.permitirHttpLocalCleartext)
    setDatasnapHttpsTunnelAtivo(config ? config.datasnap_https_tunnel_ativo : DEFAULTS.datasnapHttpsTunnelAtivo)
    setDatasnapHttpsTunnelProvedor(config ? config.datasnap_https_tunnel_provedor : DEFAULTS.datasnapHttpsTunnelProvedor)
    setDatasnapHttpsTunnelUrl(config ? config.datasnap_https_tunnel_url : DEFAULTS.datasnapHttpsTunnelUrl)
    setDatasnapHttpsTunnelHost(config ? config.datasnap_https_tunnel_host : DEFAULTS.datasnapHttpsTunnelHost)
    setDatasnapHttpsTunnelPath(config ? config.datasnap_https_tunnel_path : DEFAULTS.datasnapHttpsTunnelPath)
    setValidarSslHttpsTunnel(config ? config.validar_ssl_https_tunnel : DEFAULTS.validarSslHttpsTunnel)
    setCloudflareTunnelId(config ? config.cloudflare_tunnel_id : DEFAULTS.cloudflareTunnelId)
    setCloudflareAccessAtivo(config ? config.cloudflare_access_ativo : DEFAULTS.cloudflareAccessAtivo)
    setCloudflareAccessAudience(config ? config.cloudflare_access_audience : DEFAULTS.cloudflareAccessAudience)
    setLimparCacheAoTrocarEmpresa(config ? config.limpar_cache_ao_trocar_empresa : DEFAULTS.limparCacheAoTrocarEmpresa)
    setLimparCacheAoTrocarUrl(config ? config.limpar_cache_ao_trocar_url : DEFAULTS.limparCacheAoTrocarUrl)
    setSincronizarConfiguracaoAoEntrar(config ? config.sincronizar_configuracao_ao_entrar : DEFAULTS.sincronizarConfiguracaoAoEntrar)
    setSincronizarProdutosAoEntrar(config ? config.sincronizar_produtos_ao_entrar : DEFAULTS.sincronizarProdutosAoEntrar)
    setIntervaloSincronizacaoMin(config ? config.intervalo_sincronizacao_min : DEFAULTS.intervaloSincronizacaoMin)
    setPermitirMesa(config ? config.permitir_mesa : DEFAULTS.permitirMesa)
    setPermitirComanda(config ? config.permitir_comanda : DEFAULTS.permitirComanda)
    setPermitirDelivery(config ? config.permitir_delivery : DEFAULTS.permitirDelivery)
    setImprimirContaAoFechar(config ? config.imprimir_conta_ao_fechar : DEFAULTS.imprimirContaAoFechar)
    setBloquearMesaFechada(config ? config.bloquear_mesa_fechada : DEFAULTS.bloquearMesaFechada)
    setPermitirReimpressaoComprovante(config ? config.permitir_reimpressao_comprovante : DEFAULTS.permitirReimpressaoComprovante)
    setPermitirPagamentoSmartpos(config ? config.permitir_pagamento_smartpos : DEFAULTS.permitirPagamentoSmartpos)
    setAdquirentePadrao(config ? config.adquirente_padrao : DEFAULTS.adquirentePadrao)
    setUsarImpressaoRede(config ? config.usar_impressao_rede : DEFAULTS.usarImpressaoRede)
    setImpressoraRedeIp(config ? config.impressora_rede_ip : DEFAULTS.impressoraRedeIp)
    setImpressoraRedePorta(config ? config.impressora_rede_porta : DEFAULTS.impressoraRedePorta)
    setModeloImpressao(config ? config.modelo_impressao : DEFAULTS.modeloImpressao)
    setAppMinVersionCode(config ? config.app_min_version_code : DEFAULTS.appMinVersionCode)
    setAppVersionCodeRecomendada(config ? config.app_version_code_recomendada : DEFAULTS.appVersionCodeRecomendada)
    setBloquearAppDesatualizado(config ? config.bloquear_app_desatualizado : DEFAULTS.bloquearAppDesatualizado)
    setMensagemBloqueioApp(config ? config.mensagem_bloqueio_app : DEFAULTS.mensagemBloqueioApp)
    setHabilitaTefSitef(config ? config.habilita_tef_sitef : DEFAULTS.habilitaTefSitef)
    setSitefTipoIntegracao(config ? config.sitef_tipo_integracao : DEFAULTS.sitefTipoIntegracao)
    setSitefEmpresa(config ? config.sitef_empresa : DEFAULTS.sitefEmpresa)
    setSitefEndereco(config ? config.sitef_endereco : DEFAULTS.sitefEndereco)
    setSitefTerminal(config ? config.sitef_terminal : DEFAULTS.sitefTerminal)
    setSitefCnpjEstabelecimento(config ? config.sitef_cnpj_estabelecimento : DEFAULTS.sitefCnpjEstabelecimento)
    setSitefCnpjAutomacao(config ? config.sitef_cnpj_automacao : DEFAULTS.sitefCnpjAutomacao)
    setSitefCnpjFacilitador(config ? config.sitef_cnpj_facilitador : DEFAULTS.sitefCnpjFacilitador)
    setSitefComExterna(config ? config.sitef_com_externa : DEFAULTS.sitefComExterna)
    setSitefDoubleValidation(config ? config.sitef_double_validation : DEFAULTS.sitefDoubleValidation)
    setSitefModalidadePadrao(config ? config.sitef_modalidade_padrao : DEFAULTS.sitefModalidadePadrao)
    setSitefHabilitaPix(config ? config.sitef_habilita_pix : DEFAULTS.sitefHabilitaPix)
    setSitefHabilitaDebito(config ? config.sitef_habilita_debito : DEFAULTS.sitefHabilitaDebito)
    setSitefHabilitaCredito(config ? config.sitef_habilita_credito : DEFAULTS.sitefHabilitaCredito)
    setSitefHabilitaCancelamento(config ? config.sitef_habilita_cancelamento : DEFAULTS.sitefHabilitaCancelamento)
    setSitefHabilitaReimpressao(config ? config.sitef_habilita_reimpressao : DEFAULTS.sitefHabilitaReimpressao)
    setSitefTimeoutColeta(config ? config.sitef_timeout_coleta : DEFAULTS.sitefTimeoutColeta)
    setSitefPinpadMac(config ? config.sitef_pinpad_mac : DEFAULTS.sitefPinpadMac)
    setSitefRestricoes(config ? config.sitef_restricoes : DEFAULTS.sitefRestricoes)
    setSitefConfigJson(config ? config.sitef_config_json : DEFAULTS.sitefConfigJson)
    setConfiguracaoJson(config ? config.configuracao_json : DEFAULTS.configuracaoJson)
  }

  useEffect(() => {
    if (props.fastfoodMobileConfig) {
      preencherFormulario(props.fastfoodMobileConfig)
    } else {
      preencherFormulario(null)
    }
    return () => preencherFormulario(null)
  }, [props.fastfoodMobileConfig])

  const selecionarEmpresa = (value, availableOptions) => {
    const opcao = (availableOptions || companies).find(c => String(c.value) === String(value))
    setEmpresaId(value || null)
    setEmpresaIdInterno(opcao?.id)
    setCnpjSemMascara(opcao?.CNPJ ? opcao.CNPJ.replace(/\D/g, "") : null)
    if (value) {
      props.buscarFastfoodMobileConfigPorEmpresa({ idEmpresa: value }, props.history)
    }
  }

  const alterarEmpresa = value => selecionarEmpresa(value, companies)

  const gravar = () => {
    if (!empresaId) {
      toastr.error(t("fastfoodmobile.config.edicao.validacao.empresa"))
      return
    }
    if (!cnpjSemMascara) {
      toastr.error(t("fastfoodmobile.config.edicao.validacao.cnpj"))
      return
    }

    const dados = {
      id,
      empresa_id: empresaIdInterno,
      idEmpresa: empresaId,
      cnpj_sem_mascara: cnpjSemMascara,
      ativo,
      habilita_fastfood_mobile: habilitaFastfoodMobile,
      licenca_qtd_dispositivos: licencaQtdDispositivos ?? null,
      ambiente,
      conexao_modo: conexaoModo,
      conexao_prioridade: conexaoPrioridade,
      permitir_troca_modo_conexao_no_app: permitirTrocaModoConexaoNoApp,
      fallback_automatico: fallbackAutomatico,
      timeout_conexao_ms: timeoutConexaoMs,
      timeout_leitura_ms: timeoutLeituraMs,
      tentativas_conexao: tentativasConexao,
      datasnap_local_ativo: datasnapLocalAtivo,
      datasnap_local_protocolo: datasnapLocalProtocolo,
      datasnap_local_host: datasnapLocalHost,
      datasnap_local_porta: datasnapLocalPorta,
      datasnap_local_path: datasnapLocalPath,
      datasnap_local_url_override: datasnapLocalUrlOverride,
      permitir_http_local_cleartext: permitirHttpLocalCleartext,
      datasnap_https_tunnel_ativo: datasnapHttpsTunnelAtivo,
      datasnap_https_tunnel_provedor: datasnapHttpsTunnelProvedor,
      datasnap_https_tunnel_url: datasnapHttpsTunnelUrl,
      datasnap_https_tunnel_host: datasnapHttpsTunnelHost,
      datasnap_https_tunnel_path: datasnapHttpsTunnelPath,
      validar_ssl_https_tunnel: validarSslHttpsTunnel,
      cloudflare_tunnel_id: cloudflareTunnelId,
      cloudflare_access_ativo: cloudflareAccessAtivo,
      cloudflare_access_audience: cloudflareAccessAudience,
      limpar_cache_ao_trocar_empresa: limparCacheAoTrocarEmpresa,
      limpar_cache_ao_trocar_url: limparCacheAoTrocarUrl,
      sincronizar_configuracao_ao_entrar: sincronizarConfiguracaoAoEntrar,
      sincronizar_produtos_ao_entrar: sincronizarProdutosAoEntrar,
      intervalo_sincronizacao_min: intervaloSincronizacaoMin,
      permitir_mesa: permitirMesa,
      permitir_comanda: permitirComanda,
      permitir_delivery: permitirDelivery,
      imprimir_conta_ao_fechar: imprimirContaAoFechar,
      bloquear_mesa_fechada: bloquearMesaFechada,
      permitir_reimpressao_comprovante: permitirReimpressaoComprovante,
      permitir_pagamento_smartpos: permitirPagamentoSmartpos,
      adquirente_padrao: adquirentePadrao,
      usar_impressao_rede: usarImpressaoRede,
      impressora_rede_ip: impressoraRedeIp,
      impressora_rede_porta: impressoraRedePorta,
      modelo_impressao: modeloImpressao,
      app_min_version_code: appMinVersionCode,
      app_version_code_recomendada: appVersionCodeRecomendada,
      bloquear_app_desatualizado: bloquearAppDesatualizado,
      mensagem_bloqueio_app: mensagemBloqueioApp,
      habilita_tef_sitef: habilitaTefSitef,
      sitef_tipo_integracao: sitefTipoIntegracao,
      sitef_empresa: sitefEmpresa,
      sitef_endereco: sitefEndereco,
      sitef_terminal: sitefTerminal,
      sitef_cnpj_estabelecimento: sitefCnpjEstabelecimento ? sitefCnpjEstabelecimento.replace(/\D/g, "") : null,
      sitef_cnpj_automacao: sitefCnpjAutomacao ? sitefCnpjAutomacao.replace(/\D/g, "") : null,
      sitef_cnpj_facilitador: sitefCnpjFacilitador ? sitefCnpjFacilitador.replace(/\D/g, "") : null,
      sitef_com_externa: sitefComExterna,
      sitef_double_validation: sitefDoubleValidation,
      sitef_modalidade_padrao: sitefModalidadePadrao,
      sitef_habilita_pix: sitefHabilitaPix,
      sitef_habilita_debito: sitefHabilitaDebito,
      sitef_habilita_credito: sitefHabilitaCredito,
      sitef_habilita_cancelamento: sitefHabilitaCancelamento,
      sitef_habilita_reimpressao: sitefHabilitaReimpressao,
      sitef_timeout_coleta: sitefTimeoutColeta,
      sitef_pinpad_mac: sitefPinpadMac,
      sitef_restricoes: sitefRestricoes,
      sitef_config_json: sitefConfigJson,
      configuracao_json: configuracaoJson
    }

    if (id) {
      props.editarFastfoodMobileConfig(dados, props.history)
    } else {
      props.cadastrarFastfoodMobileConfig(dados, props.history)
    }
  }

  if (!props.user || !possuiVinculo) {
    return (<AlertaSemVinculo />)
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="breadcrumb.fastfoodmobile.config.title" />
        <StickerToolbarButtons>
          <Button
            type="button"
            color="secondary"
            className="waves-effect waves-light me-2"
            onClick={ voltarParaListagem }>
            { t("fastfoodmobile.config.edicao.botao.voltar") }
          </Button>
          { !isVisualizar && (
            <Button
              type="submit"
              color="primary"
              className="waves-effect waves-light me-2"
              disabled={ !empresaId || !((id && usePermissionEdit) || (!id && usePermissionInsert)) }
              onClick={ () => gravar() }>
              { t("fastfoodmobile.config.edicao.botao.salvar") }
            </Button>
          ) }
        </StickerToolbarButtons>

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <CardTitle className="mb-4">{ t(tituloTela) }</CardTitle>
                <Form>
                <fieldset disabled={ isVisualizar } style={ { border: "none", padding: 0, margin: 0, minInlineSize: "auto" } }>
                  <FormSelectCompany
                    attribute="empresaId"
                    value={ empresaId }
                    setValue={ alterarEmpresa }
                    options={ companies.filter(c => c.value) }
                    required={ true }
                    labelColumns={ 3 }
                    disabled={ isVisualizar }
                  />

                  <FormInputNumber
                    attribute="idEmpresaVisivel"
                    keyTranslate="fastfoodmobile.config.idempresa"
                    value={ empresaId }
                    setValue={ () => {} }
                    disabled={ true }
                    labelColumns={ 3 }
                    thousandSeparator={ false }
                  />

                  <Nav tabs>
                    <NavItem>
                      <NavLink className={ classnames({ active: tab === "geral" }) }
                                onClick={ () => setTab("geral") } style={ { cursor: "pointer" } }>
                        { t("fastfoodmobile.config.tab.geral") }
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={ classnames({ active: tab === "licenciamento" }) }
                                onClick={ () => setTab("licenciamento") } style={ { cursor: "pointer" } }>
                        { t("fastfoodmobile.config.tab.licenciamento") }
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={ classnames({ active: tab === "conexao" }) }
                                onClick={ () => setTab("conexao") } style={ { cursor: "pointer" } }>
                        { t("fastfoodmobile.config.tab.conexao") }
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={ classnames({ active: tab === "datasnapLocal" }) }
                                onClick={ () => setTab("datasnapLocal") } style={ { cursor: "pointer" } }>
                        { t("fastfoodmobile.config.tab.datasnaplocal") }
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={ classnames({ active: tab === "datasnapTunnel" }) }
                                onClick={ () => setTab("datasnapTunnel") } style={ { cursor: "pointer" } }>
                        { t("fastfoodmobile.config.tab.datasnaptunnel") }
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={ classnames({ active: tab === "sincronizacao" }) }
                                onClick={ () => setTab("sincronizacao") } style={ { cursor: "pointer" } }>
                        { t("fastfoodmobile.config.tab.sincronizacao") }
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={ classnames({ active: tab === "operacao" }) }
                                onClick={ () => setTab("operacao") } style={ { cursor: "pointer" } }>
                        { t("fastfoodmobile.config.tab.operacao") }
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={ classnames({ active: tab === "pagamentoImpressao" }) }
                                onClick={ () => setTab("pagamentoImpressao") } style={ { cursor: "pointer" } }>
                        { t("fastfoodmobile.config.tab.pagamentoimpressao") }
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={ classnames({ active: tab === "versaoApp" }) }
                                onClick={ () => setTab("versaoApp") } style={ { cursor: "pointer" } }>
                        { t("fastfoodmobile.config.tab.versaoapp") }
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={ classnames({ active: tab === "sitef" }) }
                                onClick={ () => setTab("sitef") } style={ { cursor: "pointer" } }>
                        { t("fastfoodmobile.config.tab.sitef") }
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={ classnames({ active: tab === "avancado" }) }
                                onClick={ () => setTab("avancado") } style={ { cursor: "pointer" } }>
                        { t("fastfoodmobile.config.tab.avancado") }
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={ tab } className="p-3">
                    <TabPane tabId="geral">
                      <FormInputSwitch attribute="ativo" keyTranslate="fastfoodmobile.config.ativo"
                                       value={ ativo } setValue={ setAtivo } labelColumns={ 3 } />
                      <FormInputSwitch attribute="habilitaFastfoodMobile" keyTranslate="fastfoodmobile.config.habilita-fastfood-mobile"
                                       value={ habilitaFastfoodMobile } setValue={ setHabilitaFastfoodMobile } labelColumns={ 3 } />
                      <FormInputSelect attribute="ambiente" keyTranslate="fastfoodmobile.config.ambiente"
                                       value={ ambiente } setValue={ setAmbiente } options={ getAmbienteOptions() }
                                       required={ true } labelColumns={ 3 } />
                    </TabPane>

                    <TabPane tabId="licenciamento">
                      <FormInputNumber attribute="licencaQtdDispositivos" keyTranslate="fastfoodmobile.config.licenca-qtd-dispositivos"
                                       value={ licencaQtdDispositivos } setValue={ setLicencaQtdDispositivos }
                                       disabled={ isVisualizar || !podeEditarLimiteLicenca } labelColumns={ 3 }
                                       min={ 0 } allowNegative={ false } thousandSeparator={ false } />
                      <ResumoLicencaDispositivos
                        label={ t("fastfoodmobile.config.licenca-dispositivos-resumo.label") }
                        ativos={ dispositivosAtivos }
                        inativos={ dispositivosInativos }
                        limite={ licencaQtdDispositivos }
                        saldo={ saldoDispositivos }
                        t={ t } />
                    </TabPane>

                    <TabPane tabId="conexao">
                      <FormInputSelect attribute="conexaoModo" keyTranslate="fastfoodmobile.config.conexao-modo"
                                       value={ conexaoModo } setValue={ setConexaoModo } options={ getConexaoModoOptions() }
                                       required={ true } labelColumns={ 3 } />
                      <FormInputSelect attribute="conexaoPrioridade" keyTranslate="fastfoodmobile.config.conexao-prioridade"
                                       value={ conexaoPrioridade } setValue={ setConexaoPrioridade } options={ getConexaoPrioridadeOptions() }
                                       required={ true } labelColumns={ 3 } />
                      <FormInputSwitch attribute="permitirTrocaModoConexaoNoApp" keyTranslate="fastfoodmobile.config.permitir-troca-modo-conexao-no-app"
                                       value={ permitirTrocaModoConexaoNoApp } setValue={ setPermitirTrocaModoConexaoNoApp } labelColumns={ 3 } />
                      <FormInputSwitch attribute="fallbackAutomatico" keyTranslate="fastfoodmobile.config.fallback-automatico"
                                       value={ fallbackAutomatico } setValue={ setFallbackAutomatico } labelColumns={ 3 } />
                      <FormInputNumber attribute="timeoutConexaoMs" keyTranslate="fastfoodmobile.config.timeout-conexao-ms"
                                       value={ timeoutConexaoMs } setValue={ setTimeoutConexaoMs } required={ true } labelColumns={ 3 } />
                      <FormInputNumber attribute="timeoutLeituraMs" keyTranslate="fastfoodmobile.config.timeout-leitura-ms"
                                       value={ timeoutLeituraMs } setValue={ setTimeoutLeituraMs } required={ true } labelColumns={ 3 } />
                      <FormInputNumber attribute="tentativasConexao" keyTranslate="fastfoodmobile.config.tentativas-conexao"
                                       value={ tentativasConexao } setValue={ setTentativasConexao } required={ true } labelColumns={ 3 } />
                    </TabPane>

                    <TabPane tabId="datasnapLocal">
                      <FormInputSwitch attribute="datasnapLocalAtivo" keyTranslate="fastfoodmobile.config.datasnap-local-ativo"
                                       value={ datasnapLocalAtivo } setValue={ setDatasnapLocalAtivo } labelColumns={ 3 } />
                      <FormInputSelect attribute="datasnapLocalProtocolo" keyTranslate="fastfoodmobile.config.datasnap-local-protocolo"
                                       value={ datasnapLocalProtocolo } setValue={ setDatasnapLocalProtocolo } options={ getProtocoloOptions() }
                                       required={ true } labelColumns={ 3 } />
                      <MaskedIpInput attribute="datasnapLocalHost"
                                     label={ t("fastfoodmobile.config.datasnap-local-host.label") }
                                     tooltip={ t("fastfoodmobile.config.datasnap-local-host.title") }
                                     value={ datasnapLocalHost } setValue={ setDatasnapLocalHost } />
                      <FormInputNumber attribute="datasnapLocalPorta" keyTranslate="fastfoodmobile.config.datasnap-local-porta"
                                       value={ datasnapLocalPorta } setValue={ setDatasnapLocalPorta } required={ true } labelColumns={ 3 } thousandSeparator={ false } />
                      <FormInputText attribute="datasnapLocalPath" keyTranslate="fastfoodmobile.config.datasnap-local-path"
                                     value={ datasnapLocalPath } setValue={ setDatasnapLocalPath } required={ true } maxLength={ 150 } labelColumns={ 3 } />
                      <FormInputText attribute="datasnapLocalUrlOverride" keyTranslate="fastfoodmobile.config.datasnap-local-url-override"
                                     value={ datasnapLocalUrlOverride } setValue={ setDatasnapLocalUrlOverride } maxLength={ 255 } labelColumns={ 3 } />
                      <FormInputSwitch attribute="permitirHttpLocalCleartext" keyTranslate="fastfoodmobile.config.permitir-http-local-cleartext"
                                       value={ permitirHttpLocalCleartext } setValue={ setPermitirHttpLocalCleartext } labelColumns={ 3 } />
                    </TabPane>

                    <TabPane tabId="datasnapTunnel">
                      <FormInputSwitch attribute="datasnapHttpsTunnelAtivo" keyTranslate="fastfoodmobile.config.datasnap-https-tunnel-ativo"
                                       value={ datasnapHttpsTunnelAtivo } setValue={ setDatasnapHttpsTunnelAtivo } labelColumns={ 3 } />
                      <FormInputSelect attribute="datasnapHttpsTunnelProvedor" keyTranslate="fastfoodmobile.config.datasnap-https-tunnel-provedor"
                                       value={ datasnapHttpsTunnelProvedor } setValue={ setDatasnapHttpsTunnelProvedor } options={ getTunnelProvedorOptions() }
                                       required={ true } labelColumns={ 3 } />
                      <FormInputText attribute="datasnapHttpsTunnelUrl" keyTranslate="fastfoodmobile.config.datasnap-https-tunnel-url"
                                     value={ datasnapHttpsTunnelUrl } setValue={ setDatasnapHttpsTunnelUrl } maxLength={ 255 } labelColumns={ 3 } />
                      <FormInputText attribute="datasnapHttpsTunnelHost" keyTranslate="fastfoodmobile.config.datasnap-https-tunnel-host"
                                     value={ datasnapHttpsTunnelHost } setValue={ setDatasnapHttpsTunnelHost } maxLength={ 150 } labelColumns={ 3 } />
                      <FormInputText attribute="datasnapHttpsTunnelPath" keyTranslate="fastfoodmobile.config.datasnap-https-tunnel-path"
                                     value={ datasnapHttpsTunnelPath } setValue={ setDatasnapHttpsTunnelPath } required={ true } maxLength={ 150 } labelColumns={ 3 } />
                      <FormInputSwitch attribute="validarSslHttpsTunnel" keyTranslate="fastfoodmobile.config.validar-ssl-https-tunnel"
                                       value={ validarSslHttpsTunnel } setValue={ setValidarSslHttpsTunnel } labelColumns={ 3 } />
                      <FormInputText attribute="cloudflareTunnelId" keyTranslate="fastfoodmobile.config.cloudflare-tunnel-id"
                                     value={ cloudflareTunnelId } setValue={ setCloudflareTunnelId } maxLength={ 100 } labelColumns={ 3 } />
                      <FormInputSwitch attribute="cloudflareAccessAtivo" keyTranslate="fastfoodmobile.config.cloudflare-access-ativo"
                                       value={ cloudflareAccessAtivo } setValue={ setCloudflareAccessAtivo } labelColumns={ 3 } />
                      <FormInputText attribute="cloudflareAccessAudience" keyTranslate="fastfoodmobile.config.cloudflare-access-audience"
                                     value={ cloudflareAccessAudience } setValue={ setCloudflareAccessAudience } maxLength={ 255 } labelColumns={ 3 } />
                    </TabPane>

                    <TabPane tabId="sincronizacao">
                      <FormInputSwitch attribute="limparCacheAoTrocarEmpresa" keyTranslate="fastfoodmobile.config.limpar-cache-ao-trocar-empresa"
                                       value={ limparCacheAoTrocarEmpresa } setValue={ setLimparCacheAoTrocarEmpresa } labelColumns={ 3 } />
                      <FormInputSwitch attribute="limparCacheAoTrocarUrl" keyTranslate="fastfoodmobile.config.limpar-cache-ao-trocar-url"
                                       value={ limparCacheAoTrocarUrl } setValue={ setLimparCacheAoTrocarUrl } labelColumns={ 3 } />
                      <FormInputSwitch attribute="sincronizarConfiguracaoAoEntrar" keyTranslate="fastfoodmobile.config.sincronizar-configuracao-ao-entrar"
                                       value={ sincronizarConfiguracaoAoEntrar } setValue={ setSincronizarConfiguracaoAoEntrar } labelColumns={ 3 } />
                      <FormInputSwitch attribute="sincronizarProdutosAoEntrar" keyTranslate="fastfoodmobile.config.sincronizar-produtos-ao-entrar"
                                       value={ sincronizarProdutosAoEntrar } setValue={ setSincronizarProdutosAoEntrar } labelColumns={ 3 } />
                      <FormInputNumber attribute="intervaloSincronizacaoMin" keyTranslate="fastfoodmobile.config.intervalo-sincronizacao-min"
                                       value={ intervaloSincronizacaoMin } setValue={ setIntervaloSincronizacaoMin } required={ true } labelColumns={ 3 } />
                    </TabPane>

                    <TabPane tabId="operacao">
                      <FormInputSwitch attribute="permitirMesa" keyTranslate="fastfoodmobile.config.permitir-mesa"
                                       value={ permitirMesa } setValue={ setPermitirMesa } labelColumns={ 3 } />
                      <FormInputSwitch attribute="permitirComanda" keyTranslate="fastfoodmobile.config.permitir-comanda"
                                       value={ permitirComanda } setValue={ setPermitirComanda } labelColumns={ 3 } />
                      <FormInputSwitch attribute="permitirDelivery" keyTranslate="fastfoodmobile.config.permitir-delivery"
                                       value={ permitirDelivery } setValue={ setPermitirDelivery } labelColumns={ 3 } />
                      <FormInputSwitch attribute="imprimirContaAoFechar" keyTranslate="fastfoodmobile.config.imprimir-conta-ao-fechar"
                                       value={ imprimirContaAoFechar } setValue={ setImprimirContaAoFechar } labelColumns={ 3 } />
                      <FormInputSwitch attribute="bloquearMesaFechada" keyTranslate="fastfoodmobile.config.bloquear-mesa-fechada"
                                       value={ bloquearMesaFechada } setValue={ setBloquearMesaFechada } labelColumns={ 3 } />
                      <FormInputSwitch attribute="permitirReimpressaoComprovante" keyTranslate="fastfoodmobile.config.permitir-reimpressao-comprovante"
                                       value={ permitirReimpressaoComprovante } setValue={ setPermitirReimpressaoComprovante } labelColumns={ 3 } />
                    </TabPane>

                    <TabPane tabId="pagamentoImpressao">
                      <FormInputSwitch attribute="permitirPagamentoSmartpos" keyTranslate="fastfoodmobile.config.permitir-pagamento-smartpos"
                                       value={ permitirPagamentoSmartpos } setValue={ setPermitirPagamentoSmartpos } labelColumns={ 3 } />
                      <FormInputSelect attribute="adquirentePadrao" keyTranslate="fastfoodmobile.config.adquirente-padrao"
                                       value={ adquirentePadrao } setValue={ setAdquirentePadrao } options={ getAdquirenteOptions() }
                                       required={ true } labelColumns={ 3 } />
                      <FormInputSwitch attribute="usarImpressaoRede" keyTranslate="fastfoodmobile.config.usar-impressao-rede"
                                       value={ usarImpressaoRede } setValue={ setUsarImpressaoRede } labelColumns={ 3 } />
                      <MaskedIpInput attribute="impressoraRedeIp"
                                     label={ t("fastfoodmobile.config.impressora-rede-ip.label") }
                                     tooltip={ t("fastfoodmobile.config.impressora-rede-ip.title") }
                                     value={ impressoraRedeIp } setValue={ setImpressoraRedeIp } />
                      <FormInputNumber attribute="impressoraRedePorta" keyTranslate="fastfoodmobile.config.impressora-rede-porta"
                                       value={ impressoraRedePorta } setValue={ setImpressoraRedePorta } required={ true } labelColumns={ 3 } thousandSeparator={ false } />
                      <FormInputSelect attribute="modeloImpressao" keyTranslate="fastfoodmobile.config.modelo-impressao"
                                       value={ modeloImpressao } setValue={ setModeloImpressao } options={ getModeloImpressaoOptions() }
                                       labelColumns={ 3 } />
                    </TabPane>

                    <TabPane tabId="versaoApp">
                      <FormInputNumber attribute="appMinVersionCode" keyTranslate="fastfoodmobile.config.app-min-version-code"
                                       value={ appMinVersionCode } setValue={ setAppMinVersionCode } required={ true } labelColumns={ 3 } />
                      <FormInputNumber attribute="appVersionCodeRecomendada" keyTranslate="fastfoodmobile.config.app-version-code-recomendada"
                                       value={ appVersionCodeRecomendada } setValue={ setAppVersionCodeRecomendada } required={ true } labelColumns={ 3 } />
                      <FormInputSwitch attribute="bloquearAppDesatualizado" keyTranslate="fastfoodmobile.config.bloquear-app-desatualizado"
                                       value={ bloquearAppDesatualizado } setValue={ setBloquearAppDesatualizado } labelColumns={ 3 } />
                      <FormInputText attribute="mensagemBloqueioApp" keyTranslate="fastfoodmobile.config.mensagem-bloqueio-app"
                                     value={ mensagemBloqueioApp } setValue={ setMensagemBloqueioApp } maxLength={ 255 } labelColumns={ 3 } />
                    </TabPane>

                    <TabPane tabId="sitef">
                      <FormInputSwitch attribute="habilitaTefSitef" keyTranslate="fastfoodmobile.config.habilita-tef-sitef"
                                       value={ habilitaTefSitef } setValue={ setHabilitaTefSitef } labelColumns={ 3 } />
                      <FormInputSelect attribute="sitefTipoIntegracao" keyTranslate="fastfoodmobile.config.sitef-tipo-integracao"
                                       value={ sitefTipoIntegracao } setValue={ setSitefTipoIntegracao } options={ getSitefTipoIntegracaoOptions() }
                                       required={ true } labelColumns={ 3 } />
                      <FormInputText attribute="sitefEmpresa" keyTranslate="fastfoodmobile.config.sitef-empresa"
                                     value={ sitefEmpresa } setValue={ setSitefEmpresa } maxLength={ 8 } labelColumns={ 3 } />
                      <FormInputText attribute="sitefEndereco" keyTranslate="fastfoodmobile.config.sitef-endereco"
                                     value={ sitefEndereco } setValue={ setSitefEndereco } maxLength={ 255 } labelColumns={ 3 } />
                      <FormInputText attribute="sitefTerminal" keyTranslate="fastfoodmobile.config.sitef-terminal"
                                     value={ sitefTerminal } setValue={ setSitefTerminal } maxLength={ 30 } labelColumns={ 3 } />
                      <FormInputCpfCnpj attribute="sitefCnpjEstabelecimento"
                                        description={ t("fastfoodmobile.config.sitef-cnpj-estabelecimento.label") }
                                        value={ sitefCnpjEstabelecimento || "" } setValue={ setSitefCnpjEstabelecimento }
                                        placeholder={ t("fastfoodmobile.config.sitef-cnpj-estabelecimento.placeholder") } />
                      <FormInputCpfCnpj attribute="sitefCnpjAutomacao"
                                        description={ t("fastfoodmobile.config.sitef-cnpj-automacao.label") }
                                        value={ sitefCnpjAutomacao || "" } setValue={ setSitefCnpjAutomacao }
                                        placeholder={ t("fastfoodmobile.config.sitef-cnpj-automacao.placeholder") } />
                      <FormInputCpfCnpj attribute="sitefCnpjFacilitador"
                                        description={ t("fastfoodmobile.config.sitef-cnpj-facilitador.label") }
                                        value={ sitefCnpjFacilitador || "" } setValue={ setSitefCnpjFacilitador }
                                        placeholder={ t("fastfoodmobile.config.sitef-cnpj-facilitador.placeholder") } />
                      <FormInputNumber attribute="sitefComExterna" keyTranslate="fastfoodmobile.config.sitef-com-externa"
                                       value={ sitefComExterna } setValue={ setSitefComExterna } required={ true } labelColumns={ 3 } />
                      <FormInputSwitch attribute="sitefDoubleValidation" keyTranslate="fastfoodmobile.config.sitef-double-validation"
                                       value={ sitefDoubleValidation } setValue={ setSitefDoubleValidation } labelColumns={ 3 } />
                      <FormInputNumber attribute="sitefModalidadePadrao" keyTranslate="fastfoodmobile.config.sitef-modalidade-padrao"
                                       value={ sitefModalidadePadrao } setValue={ setSitefModalidadePadrao } required={ true } labelColumns={ 3 } />
                      <FormInputSwitch attribute="sitefHabilitaPix" keyTranslate="fastfoodmobile.config.sitef-habilita-pix"
                                       value={ sitefHabilitaPix } setValue={ setSitefHabilitaPix } labelColumns={ 3 } />
                      <FormInputSwitch attribute="sitefHabilitaDebito" keyTranslate="fastfoodmobile.config.sitef-habilita-debito"
                                       value={ sitefHabilitaDebito } setValue={ setSitefHabilitaDebito } labelColumns={ 3 } />
                      <FormInputSwitch attribute="sitefHabilitaCredito" keyTranslate="fastfoodmobile.config.sitef-habilita-credito"
                                       value={ sitefHabilitaCredito } setValue={ setSitefHabilitaCredito } labelColumns={ 3 } />
                      <FormInputSwitch attribute="sitefHabilitaCancelamento" keyTranslate="fastfoodmobile.config.sitef-habilita-cancelamento"
                                       value={ sitefHabilitaCancelamento } setValue={ setSitefHabilitaCancelamento } labelColumns={ 3 } />
                      <FormInputSwitch attribute="sitefHabilitaReimpressao" keyTranslate="fastfoodmobile.config.sitef-habilita-reimpressao"
                                       value={ sitefHabilitaReimpressao } setValue={ setSitefHabilitaReimpressao } labelColumns={ 3 } />
                      <FormInputNumber attribute="sitefTimeoutColeta" keyTranslate="fastfoodmobile.config.sitef-timeout-coleta"
                                       value={ sitefTimeoutColeta } setValue={ setSitefTimeoutColeta } required={ true } labelColumns={ 3 } />
                      <FormInputText attribute="sitefPinpadMac" keyTranslate="fastfoodmobile.config.sitef-pinpad-mac"
                                     value={ sitefPinpadMac } setValue={ setSitefPinpadMac } maxLength={ 17 } labelColumns={ 3 } />
                      <FormInputText attribute="sitefRestricoes" keyTranslate="fastfoodmobile.config.sitef-restricoes"
                                     value={ sitefRestricoes } setValue={ setSitefRestricoes } maxLength={ 500 } labelColumns={ 3 } />
                    </TabPane>

                    <TabPane tabId="avancado">
                      <FormInputText attribute="sitefConfigJson" keyTranslate="fastfoodmobile.config.sitef-config-json"
                                     value={ sitefConfigJson } setValue={ setSitefConfigJson } labelColumns={ 3 } />
                      <FormInputText attribute="configuracaoJson" keyTranslate="fastfoodmobile.config.configuracao-json"
                                     value={ configuracaoJson } setValue={ setConfiguracaoJson } labelColumns={ 3 } />
                    </TabPane>
                  </TabContent>
                </fieldset>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

CadastrarFastfoodMobileConfig.propTypes = {
  user: PropTypes.any,
  history: PropTypes.object,
  match: PropTypes.object,
  location: PropTypes.object,
  fastfoodMobileConfig: PropTypes.any,
  fastfoodMobileConfigLoading: PropTypes.any,
  buscarFastfoodMobileConfigPorEmpresa: PropTypes.func,
  cadastrarFastfoodMobileConfig: PropTypes.func,
  editarFastfoodMobileConfig: PropTypes.func,
  navegarBreadCrumb: PropTypes.func
}

const mapStatetoProps = state => {
  const { fastfoodMobileConfig, fastfoodMobileConfigLoading } = state.Profile
  const { user } = state.Login
  return { user, fastfoodMobileConfig, fastfoodMobileConfigLoading }
}

export default withTranslation()(connect(mapStatetoProps, {
  buscarFastfoodMobileConfigPorEmpresa,
  cadastrarFastfoodMobileConfig,
  editarFastfoodMobileConfig,
  navegarBreadCrumb
})(withRouter(CadastrarFastfoodMobileConfig)))
